import React, { useEffect } from 'react';

import Policy from '../../Manager/Checkout/Policy/Index';
import PaymentMethod from './PaymentMethod/Index';
import BillingInformation from './BillingInformation/Index';
import InvoiceTable from '../Policy/Invoices/Table';
import Wait from '../../Manager/Checkout/Wait';

import { useManagerPolicyContext } from '../../../contexts/ManagerPolicyContext';
import { useContext as usePolicyContext } from '../Policy/Context';

export default function Main({ enterpriseId }) {
  const {
    dispatch: policyDispatch,
    actions: policyActions,
    state: policyState,
  } = useManagerPolicyContext();

  const { dispatch, actions, state } = usePolicyContext();

  useEffect(() => {
    policyActions.loadPolicy(policyDispatch, policyState.enterpriseId);
    actions.load(dispatch, state.enterpriseId);
  }, []);

  return (
    <>
      {policyState.policy == null && (
        <div className="mb20">
          <Wait />
        </div>
      )}
      {policyState.policy != null && (
        <>
          {policyState.policy.id === '' && (
            <>
              <div className="inviteTabsCheckout_main">
                <div className="inviteTabsCheckoutMain_title">Policy</div>
              </div>
              <div className="invite-wrapper inviteTabsCheckout_control">
                Add your billing method now and contact LeggUP to activate your Policy.
                Once your policy is activated, the billing method on the file will be
                used for future payments.
              </div>
            </>
          )}
          {policyState.policy.id !== '' && <Policy page="billing" /> }
          <PaymentMethod />
          <BillingInformation />

          <div className="ibox-content mt20">
            <h1>Invoice History</h1>
            <InvoiceTable adminView={false} />
          </div>
        </>
      )}
    </>
  );
}
